import moment from 'moment';
import { ReceiptTransactionDateEnum } from './Enum';

export const ReceiptUtils = {
  getTransactionDates: (value: ReceiptTransactionDateEnum) => {
    switch (value) {
      case ReceiptTransactionDateEnum.CURRENT_MONTH:
        return {
          startsAt: moment().startOf('month').format('YYYY-MM-DD'),
          endsAt: moment().format('YYYY-MM-DD'),
        };
      case ReceiptTransactionDateEnum.LAST_MONTH:
        return {
          startsAt: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          endsAt: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        };
      case ReceiptTransactionDateEnum.LAST_3_MONTHS:
        return {
          startsAt: moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),
          endsAt: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        };
      case ReceiptTransactionDateEnum.LAST_6_MONTHS:
        return {
          startsAt: moment().subtract(6, 'month').startOf('month').format('YYYY-MM-DD'),
          endsAt: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        };
      case ReceiptTransactionDateEnum.YEAR_TO_DATE:
        return {
          startsAt: moment().startOf('year').format('YYYY-MM-DD'),
          endsAt: moment().endOf('month').format('YYYY-MM-DD'),
        };
      case ReceiptTransactionDateEnum.LAST_YEAR:
        return {
          startsAt: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
          endsAt: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD'),
        };
      default:
        return {
          startsAt: '2015-01-01',
          endsAt: moment().format('YYYY-MM-DD'),
        };
    }
  },
};
